import { render, staticRenderFns } from "./recipes-config.vue?vue&type=template&id=2a073bf8"
import script from "./recipes-config.vue?vue&type=script&lang=js"
export * from "./recipes-config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports